import axios from "../libs/api.request.js";
// 地址列表
export const addressList = params => {
    return axios.request({
      url: "/pc/address",
      method: "get",
      params: params
    });
  };
// 保存地址
export const saveAddress = data => {
    return axios.request({
      url: "/pc/address",
      method: "post",
      data: data
    });
  };
// 地址详情
export const selectOneAddress = params => {
    return axios.request({
      url: "/pc/address/selectOne",
      method: "get",
      params: params
    });
  };
// shipping地址详情
export const shippingAddressOne = params => {
    return axios.request({
      url: "/pc/shipping/addressOne",
      method: "get",
      params: params
    });
  };
// shipping地址详情
export const shippingRemark = params => {
    return axios.request({
      url:`/pc/shipping/${params.id}/remark?remark=${params.remark}`,
      method: "post"
    });
  };
// 设为默认
export const setDefault = data => {
    return axios.request({
      url: "/pc/address",
      method: "put",
      params: data
    });
  };
// 删除
export const delAddress = data => {
    return axios.request({
      url: "/pc/address",
      method: "delete",
      data: data.ids
    });
  };
// 保存预约信息
export const saveCustomerNote = data => {
    return axios.request({
      url: "/pc/customer/saveCustomerNote",
      method: "post",
      data: data
    });
  };
// 获得预约信息列
export const listCustomerNote = params => {
    return axios.request({
      url: "/pc/customer/listCustomerNote",
      method: "get",
      params: params
    });
  };
// 删除
export const deleteCustomerNote = params => {
    return axios.request({
      url: "/pc/customer/deleteCustomerNote",
      method: "delete",
      params: params
    });
  };
  


// WEBPACK FOOTER //
// ./src/api/address.js